import { EventEmitter, Injectable, Output } from '@angular/core';
import { TaskModel } from '../../models/task/task.model';
import { TaskModalComponent } from 'src/app/shared/modals/task-modal/task-modal.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { BadgeCountService } from '../badgecount.service';

@Injectable({
  providedIn: 'root'
})
export class TaskModalService {

  @Output() modelChanged = new EventEmitter<any>(); 
  
  constructor( private badgeCountService:BadgeCountService, private modalService: NgbModal) { }

  openModal(model?: TaskModel, entitiesToAdd?: any[], buttonName?: string) {
    var modalRef!: NgbModalRef;

    if(model == null){
      model = new TaskModel(); 
    }

    modalRef = this.modalService.open( TaskModalComponent, { windowClass : "customModalClassUnderName",size: 'lg', centered: false, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.model = {...model}; 
    modalRef.componentInstance.entitiesToAdd = entitiesToAdd; 
    
    if(buttonName !== undefined && buttonName.length >0){
      modalRef.componentInstance.buttonName = buttonName; 
    }



    var sub: Subscription = modalRef.closed.subscribe(()=>{
      this.modelChanged.emit(modalRef.componentInstance.model);
      sub.unsubscribe();
    })

    var sub2: Subscription = this.badgeCountService.badgeCountUpdated$.subscribe(()=>{
      this.modelChanged.emit(true)
      sub2.unsubscribe();
    })
  }
}
